/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiOwnerBalanceMemes {
    'consolidation_key': string;
    'created_at': Date;
    'updated_at': Date;
    'season': number;
    'balance': number;
    'unique': number;
    'sets': number;
    'boosted_tdh': number;
    'rank': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "consolidation_key",
            "baseName": "consolidation_key",
            "type": "string",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updated_at",
            "baseName": "updated_at",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "season",
            "baseName": "season",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "balance",
            "baseName": "balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "unique",
            "baseName": "unique",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sets",
            "baseName": "sets",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "boosted_tdh",
            "baseName": "boosted_tdh",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "rank",
            "baseName": "rank",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return ApiOwnerBalanceMemes.attributeTypeMap;
    }

    public constructor() {
    }
}
